export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0025s_0000_Black-&-White-2.10719b55.png";